angular
    .module('vm.helpCenterApr21')
    .controller('HelpCenterController', HelpCenterController);

function HelpCenterController() {
    const vm = this;

    vm.sentRequestNotificationsClosed = false;
    vm.activeCategoryIds = [];
    vm.setActiveCategory = setActiveCategory;
    vm.toggleContactUs = toggleContactUs;
    vm.toggleFaq = toggleFaq;
    vm.contactUsOpen = false;
    vm.faqOpen = false;

    //////////////

    function setActiveCategory(categoryId) {
        vm.contactUsOpen = false;
        vm.faqOpen = false;
        
        const index = vm.activeCategoryIds.indexOf(categoryId);

        if (index === -1) {
            // vm.activeCategoryIds.push(categoryId);
            vm.activeCategoryIds = [categoryId];
        } else {
            // vm.activeCategoryIds.splice(index, 1);
            vm.activeCategoryIds = [];
        }
    }

    function toggleContactUs() {
        vm.contactUsOpen = !vm.contactUsOpen;
        vm.faqOpen = false;
        vm.activeCategoryIds = [];
    }

    function toggleFaq() {
        vm.faqOpen = !vm.faqOpen;
        vm.contactUsOpen = false;
        vm.activeCategoryIds = [];
    }
}